module.exports = __webpack_public_path__ + "img/no-coupon.535aa527.png";